package com.eladfinish.bible.contest.screens.settings.ui.screens

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.common.settings.KeyValueSettings
import com.eladfinish.bible.contest.complete_chapter_title
import com.eladfinish.bible.contest.constants.BooleanConstants
import com.eladfinish.bible.contest.constants.Constants.PREF_FONT_STAM
import com.eladfinish.bible.contest.constants.SharedPrefsConstants.KEY_CHAPTER_COMPLETE_TYPE
import com.eladfinish.bible.contest.constants.SharedPrefsConstants.KEY_EACH_VERSE_IN_NEW_LINE
import com.eladfinish.bible.contest.constants.SharedPrefsConstants.KEY_ENABLE_LINE_LENGTH_ACCORDING_TO_WORD_LENGTH
import com.eladfinish.bible.contest.constants.SharedPrefsConstants.KEY_HIDE_TOOLBAR_ON_SCROLL
import com.eladfinish.bible.contest.constants.SharedPrefsConstants.KEY_REMOVE_VERSE_LETTER
import com.eladfinish.bible.contest.each_verse_in_new_line
import com.eladfinish.bible.contest.hide_title_bar_on_scroll
import com.eladfinish.bible.contest.pref_description_hide_title_bar_on_scroll
import com.eladfinish.bible.contest.pref_description_hide_title_bar_on_scroll_disabled
import com.eladfinish.bible.contest.screens.settings.ui.preferences.DropdownPreference
import com.eladfinish.bible.contest.screens.settings.ui.preferences.PreferenceSwitch
import com.eladfinish.bible.contest.spaces_between_blanks
import com.eladfinish.bible.contest.ui.common.FONT_STAM_ASHKENAZ
import com.eladfinish.bible.contest.ui.common.FONT_STAM_SEFARAD
import dev.icerock.moko.resources.compose.stringResource
import kotlinx.collections.immutable.toImmutableList

@Composable
internal fun ChapterCompleteSettingsScreen(
    settings: KeyValueSettings,
) {
    DropdownPreference(
        title = stringResource(SharedRes.strings.complete_chapter_title),
        key = KEY_CHAPTER_COMPLETE_TYPE,
        enabled = false,
        entries = listOf(
            "חשיפת פסוק שלם",
            "חשיפת חצי פסוק (רישא/סיפא)",
            "חשיפת כל הרֵישוֹת",
        ).toImmutableList(),
        entryValues = listOf(
            "verse_value",
            "half_value",
            "reyshot_value",
        ).toImmutableList(),
        settings = settings,
    )
    Divider()
    PreferenceSwitch(
        title = "קביעת אורך הקו של מילה חסרה",
        key = KEY_ENABLE_LINE_LENGTH_ACCORDING_TO_WORD_LENGTH,
        defaultValue = true,
        summaryOn = "אורך קו של מילה חסרה לפי מספר אותיותיה",
        summaryOff = "אורך אחיד לקווים של מילים חסרות (להעלאת רמת הקושי)",
        settings = settings,
    )
    Divider()
    PreferenceSwitch(
        title = "רווחים בין מילים להשלמה",
        key = stringResource(SharedRes.strings.spaces_between_blanks),
        defaultValue = true,
        summaryOn = "הצג קווים כמספר המילים להשלמה (בהסתרת רישא/סיפא)",
        summaryOff = "הצג קו אחד רצוף (להעלאת רמת הקושי)",
        settings = settings,
    )
    Divider()
    PreferenceSwitch(
        title = "הסר אותיות הפסוקים",
        key = KEY_REMOVE_VERSE_LETTER,
        defaultValue = false,
        summaryOn = "הפרק יופיע ללא אותיות הפסוקים (לצרכי העתקה וכדומה)",
        summaryOff = "תוכן הפרק יכלול את אותיות (מספור) הפסוקים",
        settings = settings,
    )
    Divider()
    PreferenceSwitch(
        title = stringResource(SharedRes.strings.each_verse_in_new_line),
        key = KEY_EACH_VERSE_IN_NEW_LINE,
        defaultValue = false,
        summaryOn = stringResource(SharedRes.strings.each_verse_in_new_line),
        summaryOff = "כל פסוק מתחיל במקום שקודמו הסתיים",
        settings = settings,
    )
    Divider()
    PreferenceSwitch(
        title = stringResource(SharedRes.strings.hide_title_bar_on_scroll),
        key = KEY_HIDE_TOOLBAR_ON_SCROLL,
        defaultValue = BooleanConstants.ENABLE_HIDE_TOOLBAR_ON_SCROLL,
        summaryOn = stringResource(SharedRes.strings.pref_description_hide_title_bar_on_scroll),
        summaryOff = stringResource(SharedRes.strings.pref_description_hide_title_bar_on_scroll_disabled),
        settings = settings,
    )
    Divider()
    DropdownPreference(
        title = """גופן סת"ם - עבור הפיצ'ר של תיקון קוראים""",
        key = PREF_FONT_STAM,
        entries = listOf(
            "אשכנזי",
            "ספרדי",
        ).toImmutableList(),
        entryValues = listOf(
            FONT_STAM_ASHKENAZ,
            FONT_STAM_SEFARAD,
        ).toImmutableList(),
        settings = settings,
    )
}
